module.exports = __webpack_public_path__ + "img/THIS_FONT_IS_BOLD.033440ae.svg";